// Client-side validation for a company-logo file, mirroring the backend's rules
// (accounts/logo.py) so the user gets an instant message before any upload. The
// backend re-validates every upload — this is UX, not a security boundary.

export const ACCEPTED_LOGO_TYPES = ['image/png', 'image/jpeg']
export const ACCEPTED_LOGO_EXTENSIONS = '.png,.jpg,.jpeg'
export const MAX_LOGO_BYTES = 2 * 1024 * 1024 // 2 MB

// Helper text shown under the drop zone. NOTE: the approved mockup listed WEBP,
// but the backend (accounts/logo.py) accepts PNG/JPEG only and @react-pdf/renderer
// v3 cannot decode WebP for the worksheet footer, so advertising WebP would create
// a frontend/backend mismatch. Text kept accurate to what actually uploads.
export const LOGO_FORMATS_TEXT = 'PNG or JPG • Max size 2MB'
export const LOGO_RECOMMENDED_TEXT = 'Recommended: 300x100px or 3:1 ratio'

// Validate the raw picked/dropped file (before cropping). Returns an error
// string, or null when the file is acceptable.
export const validateLogoFile = (file) => {
    if (!file) return 'No file selected.'
    if (!ACCEPTED_LOGO_TYPES.includes(file.type)) {
        return 'Logo must be a PNG or JPEG image.'
    }
    if (file.size > MAX_LOGO_BYTES) {
        return 'Image must be 2 MB or smaller.'
    }
    return null
}
